import React, { useEffect } from "react";
import Slider from "react-slick";
import { Col, Container, Row } from "react-bootstrap";
import { usePromo } from "./hooks/usePromo";

const PromoPage = () => {
    const {
        alert,
        error,
        fetchPromo,
        fetchPromoById,
        loading,
        promo } = usePromo();

    const settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1, // Show 3 cards per row
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    useEffect(() => {
        // (async () => {
        //   const userData = await validate();
        //   setUser(userData);
        // })();
    }, [
        fetchPromo
    ]);

    return (

        <div className="slider-container bg-transparent" style={{ margin: '1rem' }}>

            <Slider {...settings}>
                {promo?.map((item) => (
                    <div key={item.id} className="bg-transparent" style={{ padding: "1rem" }}>
                        <div
                            className="promo-card"
                            style={{
                                backgroundImage: `url('${item.image}')`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                                borderRadius: "5px",
                                padding: "15px",
                                color: "white",
                                margin: "7px",
                                position: "relative",
                                minHeight: "350px", // Adjust height as needed
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-end", // Ensures content is stacked properly at the bottom
                            }}
                        >
                            <div
                                className="promo-content"
                                style={{
                                    background: "rgba(0, 0, 0, 0.3)", // Optional: Adds a semi-transparent background for better readability
                                    padding: "2px",
                                    borderRadius: "3px",
                                }}
                            >
                                <strong className="promo-code">{item?.name}</strong>
                                <p className="promo-title" style={{ color: 'white' }}>{item?.code_promo}</p>
                                <p className="promo-description">%{item?.discount}</p>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>

    );
};

export default PromoPage;